import { render, staticRenderFns } from "./ModelItem.vue?vue&type=template&id=30535768&scoped=true&"
import script from "./ModelItem.vue?vue&type=script&lang=js&"
export * from "./ModelItem.vue?vue&type=script&lang=js&"
import style0 from "./ModelItem.vue?vue&type=style&index=0&id=30535768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30535768",
  null
  
)

export default component.exports